<template>
  <el-link type="primary" :href="refLink" target="_blank">{{getI18n(refTitle)}}</el-link>
</template>

<script lang="ts">
import { defineComponent, ref, defineProps, onMounted } from 'vue'
import { rootDownLoadPath } from '../config'
import { getI18n, isEmptyString } from '../utils'

export default defineComponent({
  name: 'LinkItem'
})
</script>

<script lang="ts" setup>
const props = defineProps({
  dataValue: {
    type: String,
    require: true
  }
})

const refTitle = ref('')
const refLink = ref('')
onMounted(async () => {
  if (isEmptyString(props.dataValue)) {
    return
  }
  const parts = props.dataValue.split('|||')
  refTitle.value = parts[0]
  console.log(props.dataValue)
  if (parts.length < 3) {
    refLink.value = rootDownLoadPath + parts[1]
  } else {
    refLink.value = '/action?__action_id=' + parts[2] + '&__file_path=' + parts[1]
  }
})
</script>
